import React from "react";
import useFecth from "../../Hooks/useFetch";
import styles from "./PhotoDelete.module.css";
import { PHOTO_DELETE } from "../../Api";

const PhotoDelete = ({ id }) => {
  const { loading, request } = useFecth();

  async function handleClick() {
    const confirm = window.confirm("Tem certeza que deseja deletar?");
    if (confirm) {
      const { url, options } = PHOTO_DELETE(id);
      const { response } = await request(url, options);
      if (response.ok) window.location.reload();
    }
  }

  return (
    <>
      {loading ? (
        <button className={styles.delete} disabled>
          Deletando
        </button>
      ) : (
        <button onClick={handleClick} className={styles.delete}>
          Deletar
        </button>
      )}
    </>
  );
};

export default PhotoDelete;
